module.exports = __webpack_public_path__ + "static/img/008.cd5bdd6a.jpg";